import styled from 'styled-components';

export const MobileMarketMenuWrapperStyled = styled.div`
    position: relative;
    
    &.desktop {
        padding: 0 32px;
    }
    
    .arrow-left, .arrow-right {
        position: absolute;
        top: -2px;
    }

    .arrow-left {
        left: 0;
    }

    .arrow-right {
        right: 0;
    }
`;

export const MobileMarketMenuStyled = styled.div`
    display: flex;
    gap: 8px;
    overflow: auto;

    &.mobile {
        margin: 0 -16px;
        padding: 0 16px;
    }

    button {
        padding: 4px 16px;
        font-size: 14px;
    }
`;
